import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=0aaa3c75&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=0aaa3c75&scoped=true&lang=css&"
import style1 from "./Cooperation.vue?vue&type=style&index=1&id=0aaa3c75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa3c75",
  null
  
)

export default component.exports